module.exports = __webpack_public_path__ + "cb76c13f04ca9733bf3ee38d7787c0cf.svg";